import { TRPCError } from "@trpc/server";

export const BAD_REQUEST_CODE = "BAD_REQUEST";

export const badRequestError = (message?: string) => {
  return new TRPCError({
    code: BAD_REQUEST_CODE,
    message: message ?? "Bad request",
  });
};

export const UNAUTHORIZED_CODE = "UNAUTHORIZED";

export const unauthorizedError = (message?: string) => {
  return new TRPCError({
    code: UNAUTHORIZED_CODE,
    message: message ?? "Unauthorized",
  });
};

export const FORBIDDEN_CODE = "FORBIDDEN";

export const forbiddenError = (message?: string) => {
  return new TRPCError({
    code: FORBIDDEN_CODE,
    message: message ?? "Forbidden",
  });
};

export const NOT_FOUND_CODE = "NOT_FOUND";

export const notFoundError = (message?: string) => {
  return new TRPCError({
    code: NOT_FOUND_CODE,
    message: message ?? "Not found",
  });
};

const INTERNAL_SERVER_ERROR_CODE = "INTERNAL_SERVER_ERROR";

export const internalServerError = (message?: string) => {
  return new TRPCError({
    code: INTERNAL_SERVER_ERROR_CODE,
    message: message ?? "Internal server error",
  });
};

// Expected TRPC error codes (user-facing, not bugs)
// These are normal business logic errors that should not create Sentry issues
export const EXPECTED_TRPC_CODES = [
  NOT_FOUND_CODE,
  FORBIDDEN_CODE,
  UNAUTHORIZED_CODE,
  BAD_REQUEST_CODE,
] as const;
